import { useEffect, useState } from 'react';
import { Box, Stack, useMediaQuery, useTheme } from '@mui/material';
import { useAzureMap } from '@chr/online-shared-ui-maps';
import { KeySetStack, KeyNameBox, KeyColorBox, KeyContainerBox, ThemeStyles } from './WeatherKeyEntities';
import { useTrackingMap } from './TrackingMapProvider';

const LightStyles: ThemeStyles = {
    backgroundColor: '#FFFFFF',
    color: '#000000'
};

const DarkStyles: ThemeStyles = {
    backgroundColor: '#36383A',
    color: '#FFFFFF'
};

export const WeatherKey = () => {
    const { map, isWeatherEnabled } = useTrackingMap();

    const muiTheme = useTheme();
    const isLgOrSmaller = useMediaQuery(muiTheme.breakpoints.down('lg'));
    const isSmOrSmaller = useMediaQuery(muiTheme.breakpoints.down('sm'));
    const { mapStyle } = useAzureMap();
    const [isDarkTheme, setIsDarkTheme] = useState(false);

    useEffect(() => {
        if (map && mapStyle.length > 0) {
            setIsDarkTheme(mapStyle !== 'road');
        }
    }, [map, mapStyle]);

    if (isWeatherEnabled && !isSmOrSmaller) {
        return (
            <Box
                sx={{
                    position: 'absolute',
                    display: 'flex',
                    bottom: isLgOrSmaller ? '76px' : '32px',
                    width: '100%',
                    pointerEvents: 'none'
                }}
            >
                <Box sx={{ margin: 'auto' }}>
                    <KeyContainerBox themestyles={isDarkTheme ? DarkStyles : LightStyles} data-testid="wkey-container">
                        <Stack direction={{ md: 'column', lg: 'row' }}>
                            <KeySetStack direction="row" addverticalpadding={isLgOrSmaller}>
                                <KeyNameBox>Rain</KeyNameBox>
                                <KeyColorBox iconcolor="#93C701" />
                                <KeyColorBox iconcolor="#FFD701" />
                                <KeyColorBox iconcolor="#F05514" />
                                <KeyColorBox iconcolor="#DC250E" />
                            </KeySetStack>
                            <KeySetStack direction="row" addverticalpadding={isLgOrSmaller}>
                                <KeyNameBox>Snow</KeyNameBox>
                                <KeyColorBox iconcolor="#9EC8F2" />
                                <KeyColorBox iconcolor="#2A8FDB" />
                                <KeyColorBox iconcolor="#144BED" />
                                <KeyColorBox iconcolor="#020096" />
                            </KeySetStack>
                            <KeySetStack direction="row" addverticalpadding={isLgOrSmaller}>
                                <KeyNameBox>Ice</KeyNameBox>
                                <KeyColorBox iconcolor="#E6A5C8" />
                                <KeyColorBox iconcolor="#D24FA0" />
                                <KeyColorBox iconcolor="#B71691" />
                                <KeyColorBox iconcolor="#7A1570" />
                            </KeySetStack>
                            <KeySetStack direction="row" addverticalpadding={false}>
                                <KeyNameBox>Mixed</KeyNameBox>
                                <KeyColorBox iconcolor="#C196E6" />
                                <KeyColorBox iconcolor="#AE6EE6" />
                                <KeyColorBox iconcolor="#8A32D7" />
                                <KeyColorBox iconcolor="#6500BA" />
                            </KeySetStack>
                        </Stack>
                    </KeyContainerBox>
                </Box>
            </Box>
        );
    }

    return null;
};
